import { render } from "./FormCompleteFooter.vue?vue&type=template&id=067c496a&scoped=true"
import script from "./FormCompleteFooter.vue?vue&type=script&lang=js"
export * from "./FormCompleteFooter.vue?vue&type=script&lang=js"

import "./FormCompleteFooter.vue?vue&type=style&index=0&id=067c496a&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/osod-form/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067c496a"]])

export default __exports__